<template>
  <Dialog :value="value" @close="closeDialog">
    <div class="text-xl text-gray-800">
      {{ title }}
    </div>
    <div class="text-sm text-gray-700 my-4">
      {{ message }}
    </div>
    <Button
      type="button"
      name="button"
      class="mt-2"
      color="default"
      :label="buttonText"
      @click="closeDialog"
    />
  </Dialog>
</template>

<script>
import Button from '@/components/Button.vue';
import Dialog from '@/components/Dialog.vue';

export default {
  name: 'ActionDialog',
  components: {
    Button,
    Dialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'OK',
    },
  },
  emits: ['close'],
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
